import Fuse from 'fuse.js';
const BASE_URL = '/api/collections/tv_packages/entries/';

export default (id) => ({
  channels: [],
  filteredChannels: [],
  query: '',
  fuseOptions: {
    minMatchCharLength: 1,
    findAllMatches: true,
    threshold: 0.3,
    keys: ['title', 'description'],
  },

  filter() {
    if (this.query.length > 0) {
      const fuse = new Fuse(this.channels, this.fuseOptions);
      this.filteredChannels = fuse.search(this.query);
    }
  },

  init() {
    const site = document.documentElement.lang;
    fetch(BASE_URL + id + '?filter[site]=' + site)
      .then((response) => response.json())
      .then((response) => {
        this.channels = response.data.channels;
      });
  },
});
